import { Breadcrumbs, ClickAwayListener, Grow, Link, MenuItem, MenuList, Paper, Popper, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import FormContainer from "../../../../../common/components/form_container"
import DefaultFormInput from "../../../../../common/components/default_form_input"
import AlertError from "../../../../../common/components/alert_error"
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input"
import { FormPercentageMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_percentage_masked_input"
import { BackButton } from "../../../../../common/components/back_button"
import BottomBar from "../../../../../common/components/bottom_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { CadastroInformacoesFaturamentoModal } from "./components/cadastro_informacaoes_faturamento_modal"
import { useCentroCustoCadastroViewModel } from "../../viewModels/centro_custo_cadastro_view_model"
import { useMemo } from "react"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { GenerateCentroCustoEnderecoColumnsDefinition } from "./columns/generate_centro_custo_endereco"
import { InformacaoFaturamento } from "../../../domain/models/informacao_faturamento"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { CentroCustoEndereco } from "../../../domain/models/centro_custo_endereco"
import { CadastroCentroCustoEnderecoModal } from "./components/cadastro_centro_custo_endereco_modal"
import { GenerateInformacaoFaturamentoColumnsDefinition } from "./columns/generate_informacao_faturamento"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { Link as LinkTo } from 'react-router';


export const CentroCusto_cadastro = () => {

    const viewModel = useCentroCustoCadastroViewModel();

    const dependenteColumnsDefinition = useMemo(() => {
        return GenerateInformacaoFaturamentoColumnsDefinition({
            onActionEdit: viewModel.handleInformacoesFaturamentoModalOpenState,
            onActionDelete: viewModel.handleInformacaoFaturamentoDeleteOpenState,
        });
    }, [viewModel.handleInformacoesFaturamentoModalOpenState, viewModel.handleInformacaoFaturamentoDeleteOpenState]);

    const centroCustoEnderecoColumnsDefinition = useMemo(() => {
        return GenerateCentroCustoEnderecoColumnsDefinition({
            onActionEdit: viewModel.handleCentroCustoEnderecoModalOpenState,
            onActionDelete: viewModel.handleCentroCustoEnderecoDeleteOpenState,
        });
    }, [viewModel.handleCentroCustoEnderecoModalOpenState, viewModel.handleCentroCustoEnderecoDeleteOpenState]);


    const tabelaInformacaoFaturamento = useMemo(() => {
        return (
            <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                <StyledDataGrid
                    tableName="centro_custo_cadastro_1"
                    disableColumnMenu={false}
                    getRowId={(row: InformacaoFaturamento) => row.idInformacaoFaturamento}
                    columns={dependenteColumnsDefinition}
                    loading={viewModel.loading}
                    autoHeight={true}
                    rows={viewModel.informacaoFaturamentolist}
                    rowCount={viewModel.informacaoFaturamentolist.length}
                    pageSizeOptions={[5]}
                    paginationMode="server"
                    paginationModel={{
                        page: viewModel.pagination.informacaoFaturamentos.page,
                        pageSize: viewModel.pagination.informacaoFaturamentos.rowsPerPage,
                    }} />

                <TablePagination
                    component="div"
                    count={viewModel.pagination.informacaoFaturamentos.totalItems}
                    page={viewModel.pagination.informacaoFaturamentos.page - 1}
                    rowsPerPageOptions={[5]}
                    onPageChange={(_, p) => viewModel.handleInformacaoFaturamentoPageChange(p)}
                    rowsPerPage={viewModel.pagination.informacaoFaturamentos.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleInformacaoFaturamentoRowsPerPageChange(parseInt(e.target.value))} />

            </div>
        );
    }, [
        viewModel,
        dependenteColumnsDefinition,
    ]);

    const tabelaCentroCustoEndereco = useMemo(() => {
        return (
            <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                <StyledDataGrid
                    tableName="centro_custo_cadastro_2"
                    disableColumnMenu={false}
                    getRowId={(row: CentroCustoEndereco) => row.idCentroCustoEndereco}
                    columns={centroCustoEnderecoColumnsDefinition}
                    loading={viewModel.loading}
                    autoHeight={true}
                    rows={viewModel.centroCustoEnderecoList}
                    rowCount={viewModel.centroCustoEnderecoList.length}
                    pageSizeOptions={[5]}
                    paginationMode="server"
                    paginationModel={{
                        page: viewModel.pagination.centroCustoEnderecos.page,
                        pageSize: viewModel.pagination.centroCustoEnderecos.rowsPerPage,
                    }} />

                <TablePagination
                    component="div"
                    count={viewModel.pagination.centroCustoEnderecos.totalItems}
                    page={viewModel.pagination.centroCustoEnderecos.page - 1}
                    rowsPerPageOptions={[5]}
                    onPageChange={(_, p) => viewModel.handleCentroCustoEnderecoPageChange(p)}
                    rowsPerPage={viewModel.pagination.informacaoFaturamentos.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleCentroCustoEnderecoRowsPerPageChange(parseInt(e.target.value))} />

            </div>
        );
    }, [
        viewModel,
        centroCustoEnderecoColumnsDefinition,
    ]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="w-full justify-end flex gap-2">
                            <div className="flex flex-row w-full justify-end gap-2" >
                                <BackButton
                                    onClick={() => viewModel.handlePageBack()} />

                                <div>
                                    <Stack direction="row" spacing={2}>
                                        <div className="w-[12rem]">
                                            <PrimaryButton
                                                ref={viewModel.menuRef}
                                                id="composition-button"
                                                aria-controls={viewModel.openMenu ? 'composition-menu' : undefined}
                                                aria-expanded={viewModel.openMenu ? 'true' : undefined}
                                                aria-haspopup="true"
                                                onClick={viewModel.handleToggleMenu}
                                                buttonColor="primary-green">
                                                Opções
                                            </PrimaryButton>
                                            <Popper
                                                style={{ zIndex: 10000 }}
                                                open={viewModel.openMenu}
                                                anchorEl={viewModel.menuRef.current}
                                                role={undefined}
                                                placement="bottom-start"
                                                transition
                                                disablePortal
                                            >
                                                {({ TransitionProps, placement }) => (
                                                    <Grow
                                                        {...TransitionProps}
                                                        style={{
                                                            transformOrigin:
                                                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                        }}
                                                    >
                                                        <Paper>
                                                            <ClickAwayListener onClickAway={viewModel.handleCloseMenu}>
                                                                <MenuList
                                                                    autoFocusItem={viewModel.openMenu}
                                                                    id="composition-menu"
                                                                    aria-labelledby="composition-button"
                                                                    onKeyDown={viewModel.handleListKeyDown}>
                                                                    <MenuItem onClick={() => viewModel.handleNewCentroCusto()}>Novo centro de custo</MenuItem>
                                                                    <MenuItem onClick={() => viewModel.handleCentroCustoDeleteOpenState(viewModel.selectedCentroCusto?.idCentroCusto ?? 0, true)}>Excluir centro de custo</MenuItem>
                                                                </MenuList>
                                                            </ClickAwayListener>
                                                        </Paper>
                                                    </Grow>
                                                )}
                                            </Popper>
                                        </div>
                                    </Stack>
                                </div>

                            </div>
                        </div>
                    }
                />
            </PageTopBar>
            <form className="pb-8" onSubmit={viewModel.hanldleSalvarCentroCusto}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Comercial
                        </Link>
                        <Link underline="hover" color="inherit" component={'span'}>
                            <LinkTo to='/CentroCusto_lista'>  Centro custo Lista  </LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Cadastro Centro Custo
                        </Typography>
                    </Breadcrumbs>

                    <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white"> Centro Custo</h1>
                            <RefreshButton onClick={() => { }} />
                        </div>
                    </div>

                    {
                        "" === undefined ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={""}
                                    onTryAgain={() => { }} />
                            </div>
                        ) : (
                            <>
                            </>
                        )
                    }
                    <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
                        <FormContainer title='Cadastro de Centro de Custo' arrangement='fullRow' border={false}>
                            <div className="flex flex-col items-start w-full gap-4">
                                <div className="w-[25rem]">
                                    <FormRadioGroupInput
                                        name='status'
                                        label='Status'
                                        options={[
                                            { id: 0, label: 'Ativo' },
                                            { id: 1, label: 'Bloqueado' },
                                            { id: 2, label: 'Encerrado' },
                                        ]}
                                        reactHookForm={viewModel.hookForm} />
                                </div>

                                <div className="w-[25rem]">
                                    <DefaultFormInput
                                        name='codigo'
                                        label='Código'
                                        required={true}
                                        reactHookForm={viewModel.hookForm} />
                                </div>
                                <div className="w-[50rem]">
                                    <DefaultFormInput
                                        name='descricao'
                                        label='Nome de Centro de Custo'
                                        multiline
                                        rows={3}
                                        maxRows={5}
                                        required={true}
                                        reactHookForm={viewModel.hookForm} />
                                </div>
                                <div className="w-[25rem]">
                                    <FormPercentageMaskedInput
                                        name='bdi'
                                        label='BDI'
                                        required={false}
                                        reactHookForm={viewModel.hookForm} />
                                </div>
                                <div className="w-[25rem]">
                                    <FormPercentageMaskedInput
                                        name='bdi2'
                                        label='BDI 02'
                                        required={false}
                                        reactHookForm={viewModel.hookForm} />
                                </div>
                                <div className="w-[25rem]">
                                    <DefaultFormInput
                                        name='numeroCno'
                                        label='N° CNO'
                                        required={false}
                                        reactHookForm={viewModel.hookForm} />
                                </div>
                            </div>
                        </FormContainer>
                        {
                            viewModel.selectedCentroCusto &&
                            <>
                                <div className="w-full flex flex-row justify-between items-center mt-8 mb-2">
                                    <h1 className="font-bold text-black dark:text-white text-3xl">Informações para Faturamento</h1>
                                    <div>
                                        <PrimaryButton
                                            startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                            sx={{ px: 2 }}
                                            onClick={() => viewModel.handleInformacoesFaturamentoModalOpenState(null, true)}>
                                            Novo Item
                                        </PrimaryButton>
                                    </div>
                                </div>
                                {tabelaInformacaoFaturamento}
                            </>
                        }

                        {/* OUTROS ENDEREÇOS */}
                        {
                            viewModel.selectedCentroCusto &&
                            <>
                                <div className="w-full flex flex-row justify-between items-center mt-8 mb-2">
                                    <h1 className="font-bold text-black dark:text-white text-3xl">Endereço de entrega de materiais e serviços</h1>
                                    <div>
                                        <PrimaryButton
                                            startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                            sx={{ px: 2 }}
                                            onClick={() => viewModel.handleCentroCustoEnderecoModalOpenState(null, true)}>
                                            Novo Item
                                        </PrimaryButton>
                                    </div>
                                </div>
                                {tabelaCentroCustoEndereco}
                            </>
                        }

                        <div className="w-full mt-8 mb-2">
                            <h3 className="text-base font-medium mb-2">Observações</h3>

                            <DefaultFormInput
                                name='obsCentroCusto'
                                label=''
                                minRows={10}
                                maxRows={20}
                                multiline
                                required={false}
                                reactHookForm={viewModel.hookForm}
                            />

                            <hr className="mt-4" />
                        </div>
                    </div>

                </div >
                <BottomBar>
                    <div className="w-full h-full items-center justify-between flex p-4">
                        <div>
                            {
                                viewModel.selectedCentroCusto &&
                                <>
                                    <div>
                                        <PrimaryButton
                                            buttonColor="yellow"
                                            onClick={() => viewModel.handleOpenChangeHistory(viewModel.selectedCentroCusto?.idCentroCusto ?? null, null)}>
                                            <span className="text-xs">
                                                Historico de alterações
                                            </span>
                                        </PrimaryButton>
                                    </div>
                                </>
                            }
                        </div>
                        <div className="flex flex-row gap-4">
                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1
                                    className="text-sm text-black dark:text-white"
                                    onClick={() => viewModel.handlePageBack()}>
                                    Cancelar
                                </h1>
                            </div>
                            <div className="w-[130px]">
                                {viewModel.saving
                                    ? (
                                        <PrimaryButton>
                                            Salvando...
                                        </PrimaryButton>
                                    ) : (
                                        <PrimaryButton
                                            type="submit"
                                            startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                                            Salvar
                                        </PrimaryButton>
                                    )}
                            </div>
                        </div>
                    </div>
                </BottomBar>
            </form >


            {/**
        * Modal de informações para faturamento.
            */}
            < CadastroInformacoesFaturamentoModal
                open={viewModel.openInformacaoFaturamentoModal}
                onClose={() => viewModel.handleInformacoesFaturamentoModalOpenState(null, false)}
                onSubmit={viewModel.handleSalvarInformacaoFaturamento}
                saving={viewModel.saving}
                selectedInformacaoFaturamento={viewModel.selectedInformacaoFaturamento}
                listDropDownClientes={viewModel.listDropDownClientes ?? []}
                hookForm={viewModel.hookFormFaturamento}
                onOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onLoadCep={viewModel.handleLoadCep}
                onGetClienteById={viewModel.handleGetClienteById}
            />

            <CadastroCentroCustoEnderecoModal
                open={viewModel.openCentroCustoEnderecoModal}
                onClose={() => viewModel.handleCentroCustoEnderecoModalOpenState(null, false)}
                onSubmit={viewModel.handleSalvarCentroCustoEndereco}
                saving={viewModel.saving}
                selectedCentroCustoEndereco={viewModel.selectedCentroCustoEndereco}
                hookForm={viewModel.hookFormEndereco}
                onOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onLoadCep={viewModel.handleLoadCep}
            />

            <DeleteDialog
                open={viewModel.openCentroCustoDeleteModal}
                onClose={() => viewModel.handleCentroCustoDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este centro de custo?`}
                onDelete={viewModel.handleConfirmarDeletarCentroCusto} />

            <DeleteDialog
                open={viewModel.openInformacaoFaturamentoDeleteModal}
                onClose={() => viewModel.handleInformacaoFaturamentoDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este Faturamento?`}
                onDelete={viewModel.handleConfirmarDeletarInformacaoFaturamento} />

            <DeleteDialog
                open={viewModel.openCentroCustoEnderecoDeleteModal}
                onClose={() => viewModel.handleCentroCustoEnderecoDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este Endereço?`}
                onDelete={viewModel.handleConfirmarDeletarCentroCustoEndereco} />


            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

        </>
    )
}